<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="row">
                    <!-- Image -->
                    <div role="group" class="form-group col-12 col-xl-4">
                        <label class=""> {{ $t('imagesMandatory') }}</label>
                        <GalleryPicker class="gallery-picker" v-model="specie.images" :ratioWidth="1" :ratioHeight="1" v-bind:class="{ 'is-invalid': genericValidator(specie.images, attemptedSubmit) === false || errorValidator('Image') === false }"></GalleryPicker>
                    </div>
                    <!-- Latin information -->
                    <div class="d-flex flex-column col-12 col-xl-8 justify-content-center">
                        <p class="font-weight-bold">{{$t("latinInfo")}}</p>
                        <div class="d-flex gap-1">
                            <!-- Names -->
                            <div role="group" class="form-group w-50">
                                <label class=""> {{ $t('nameMandatory') }}</label>
                                <CInput type="text" v-model="specie.name" :invalid-feedback="errorOutput['Name']" :is-valid="genericValidator(specie.name, attemptedSubmit) && errorValidator('Name')"></CInput>
                            </div>  
                            <!-- SubSpecie -->
                            <div role="group" class="form-group w-50">
                                <label class=""> {{ $t('subSpecieMandatory') }}</label>
                                <CInput type="text" v-model="specie.subSpecie" :invalid-feedback="errorOutput['SubSpecie']" :is-valid="genericValidator(specie.subSpecie, attemptedSubmit) && errorValidator('SubSpecie')"></CInput>
                            </div>       
                        </div>
                        <div class="d-flex gap-1">
                            <!-- Descriptor -->
                            <div role="group" class="form-group w-50">
                                <label class=""> {{ $t('descriptorMandatory') }}</label>
                                <CInput type="text" v-model="specie.descriptor" :invalid-feedback="errorOutput['Descriptor']" :is-valid="genericValidator(specie.descriptor, attemptedSubmit) && errorValidator('Descriptor')"></CInput>
                            </div>  
                            <!-- Gender -->
                            <div role="group" class="form-group w-50">
                            <label class=""> {{ $t('genderMandatory') }}</label>
                                <CInput type="text" v-model="specie.gender" :invalid-feedback="errorOutput['Gender']" :is-valid="genericValidator(specie.gender, attemptedSubmit) && errorValidator('Gender')"></CInput>
                            </div>  
                        </div>
                        <div class="d-flex gap-1">
                            <!-- Family -->
                            <div role="group" class="form-group w-50">
                                <label class=""> {{ $t('familyMandatory') }}</label>
                                <CInput type="text" v-model="specie.family" :invalid-feedback="errorOutput['Family']" :is-valid="genericValidator(specie.family, attemptedSubmit) && errorValidator('Family')"></CInput>
                            </div>           
                            <!-- Order -->
                            <div role="group" class="form-group w-50">
                                <label class=""> {{ $t('orderMandatory') }}</label>
                                <CInput type="text" v-model="specie.order" :invalid-feedback="errorOutput['Order']" :is-valid="genericValidator(specie.order, attemptedSubmit) && errorValidator('Order')"></CInput>
                            </div>    
                        </div>
                        <div class="d-flex gap-1">
                            <!-- Class -->
                            <div role="group" class="form-group w-50">
                                <label class=""> {{ $t('classMandatory') }}</label>
                                <CInput type="text" v-model="specie.class" :invalid-feedback="errorOutput['Class']" :is-valid="genericValidator(specie.class, attemptedSubmit) && errorValidator('Class')"></CInput>
                            </div>           
                            <!-- SubClass -->
                            <div role="group" class="form-group w-50">
                                <label class=""> {{ $t('subClassMandatory') }}</label>
                                <CInput type="text" v-model="specie.subclass" :invalid-feedback="errorOutput['SubClass']" :is-valid="genericValidator(specie.subclass, attemptedSubmit) && errorValidator('SubClass')"></CInput>
                            </div>    
                        </div>               
                        <div class="d-flex gap-1">
                            <!-- Division -->
                            <div role="group" class="form-group w-50">
                                <label class=""> {{ $t('divisionMandatory') }}</label>
                                <CInput type="text" v-model="specie.division" :invalid-feedback="errorOutput['Division']" :is-valid="genericValidator(specie.division, attemptedSubmit) && errorValidator('Division')"></CInput>
                            </div>           
                            <!-- SubDivision -->
                            <div role="group" class="form-group w-50">
                                <label class=""> {{ $t('subDivisionMandatory') }}</label>
                                <CInput type="text" v-model="specie.subdivision" :invalid-feedback="errorOutput['SubDivision']" :is-valid="genericValidator(specie.subdivision, attemptedSubmit) && errorValidator('SubDivision')"></CInput>
                            </div> 
                        </div> 
                    </div>
                </div>   
                <!-- Multilanguage fields -->   
                <div class="d-flex justify-content-between">
                    <p class="font-weight-bold">{{$t("multilanguageInfo")}}</p>
                    <!-- Language dropdown -->
                    <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                </div>
                <div class="d-flex gap-1">
                    <!-- PhysioGnomicTypes -->
                    <div role="group" class="form-group w-50">
                        <label class=""> {{ $t('physioGnomicTypesMandatory') }}</label>
                        <CInput type="text" v-model="specie.physioGnomicTypes[currentLanguage.key]" :invalid-feedback="errorOutput['PhysioGnomicTypes']" :is-valid="genericValidator(specie.physioGnomicTypes, attemptedSubmit) && errorValidator('PhysioGnomicTypes')"></CInput>
                    </div>          
                    <!-- GeneralDistributions -->
                    <div role="group" class="form-group w-50">
                        <label class=""> {{ $t('generalDistributionsMandatory') }}</label>
                        <CInput type="text" v-model="specie.generalDistributions[currentLanguage.key]" :invalid-feedback="errorOutput['GeneralDistributions']" :is-valid="genericValidator(specie.generalDistributions, attemptedSubmit) && errorValidator('GeneralDistributions')"></CInput>
                    </div>          
                </div>
                <div class="d-flex gap-1">
                    <!-- CommonNames -->
                    <div role="group" class="form-group w-50">
                        <label class=""> {{ $t('commonNamesMandatory') }}</label>
                        <vue-tags-input :placeholder="$t('addCommonName')" v-for="language in supportedLanguages" :key="language.key" v-show="currentLanguage.key == language.key" v-model="commonName" :tags="specie.commonNames[language.key]" @tags-changed="newTags => specie.commonNames[language.key] = newTags.map(x => x.text)" class="form-group" v-bind:class="{ 'is-invalid': genericValidator(specie.commonNames, attemptedSubmit) === false || errorValidator('CommonNames') === false }"/>
                        <div v-if="genericValidator(specie.commonNames, attemptedSubmit) === false || errorValidator('CommonNames') === false" class="invalid-feedback d-block">{{errorOutput['CommonNames']}}</div>
                    </div>          
                    <!-- Habitats -->
                    <div role="group" class="form-group w-50">
                        <label class=""> {{ $t('habitatsMandatory') }}</label>
                        <vue-tags-input :placeholder="$t('addHabitat')" v-for="language in supportedLanguages" :key="language.key" v-show="currentLanguage.key == language.key" v-model="habitat" :tags="specie.habitats[language.key]" @tags-changed="newTags => specie.habitats[language.key] = newTags.map(x => x.text)" class="form-group" v-bind:class="{ 'is-invalid': genericValidator(specie.habitats, attemptedSubmit) === false || errorValidator('Habitats') === false }"/>
                        <div v-if="genericValidator(specie.habitats, attemptedSubmit) === false || errorValidator('Habitats') === false" class="invalid-feedback d-block">{{errorOutput['Habitats']}}</div>
                    </div>      
                </div>   
                <!-- Other information -->
                <p class="font-weight-bold">{{$t("otherInfo")}}</p>
                <div class="d-flex gap-1"> 
                    <!-- Locations -->
                    <div role="group" class="form-group w-50">
                        <label class=""> {{ $t('locationsMandatory') }}</label>
                        <OptionsDropdown v-model="specie.locations" :options="locationsOptions" :title="$t('locations')" :index="0" :is-valid="genericValidator(specie.locations, attemptedSubmit) && errorValidator('Locations')" :invalid-feedback="errorOutput['Locations']"></OptionsDropdown>
                    </div>          
                    <!-- Synonyms -->
                    <div role="group" class="form-group w-50">
                        <label class=""> {{ $t('synonymsMandatory') }}</label>
                        <vue-tags-input :placeholder="$t('addSynonym')" v-model="synonym" :tags="specie.synonyms" @tags-changed="newTags => specie.synonyms = newTags.map(x => x.text)" class="form-group" v-bind:class="{ 'is-invalid': genericValidator(specie.synonyms, attemptedSubmit) === false || errorValidator('Synonyms') === false }"/>
                        <div v-if="genericValidator(specie.synonyms, attemptedSubmit) === false || errorValidator('Synonyms') === false" class="invalid-feedback d-block">{{errorOutput['Synonyms']}}</div>
                    </div>     
                </div>     
                <div class="d-flex gap-1">
                    <!-- FloweringStartSeason -->
                    <div role="group" class="form-group w-50">
                        <label class=""> {{ $t('floweringStartSeasonMandatory') }}</label>
                        <SingleOptionDropdown v-model="specie.floweringStartSeason" :options="monthOptions" :title="$t('floweringStartSeasonMandatory')" :index="1" :is-valid="genericValidator(specie.floweringStartSeason, attemptedSubmit) && errorValidator('FloweringStartSeason')" :invalid-feedback="errorOutput['FloweringStartSeason']"></SingleOptionDropdown>
                    </div>          
                    <!-- FloweringEndSeason -->
                    <div role="group" class="form-group w-50">
                        <label class=""> {{ $t('floweringEndSeasonMandatory') }}</label>
                        <SingleOptionDropdown v-model="specie.floweringEndSeason" :options="monthOptions" :title="$t('floweringEndSeasonMandatory')" :index="1" :is-valid="genericValidator(specie.floweringEndSeason, attemptedSubmit) && errorValidator('FloweringEndSeason')" :invalid-feedback="errorOutput['FloweringEndSeason']"></SingleOptionDropdown>
                    </div>          
                </div>
                <!-- Action button + submitting -->  
                <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                <CButton v-else type="button" class="btn btn-primary align-self-end" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                <!-- Loading -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { mapState } from 'vuex'
import router from '@/router/index';

import { deepClone } from "@/helpers/utils.js";
import { CONSTANTS } from '@/helpers/consts';
import { genericValidator, errorValidator } from "@/helpers/utils.js";
import { API_HELPER } from "@/helpers/api.js";

import Specie from "@/classes/Specie";

import LanguageDropdown from '@/controls/LanguageDropdown.vue'
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import FormLoading from '@/controls/FormLoading.vue'
import GalleryPicker from '@/controls/GalleryPicker.vue'
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'
import OptionsDropdown from '@/controls/OptionsDropdown.vue'
import VueTagsInput from '@johmun/vue-tags-input';

  export default {
    components: { LanguageDropdown, ConfirmationPopUp, FormLoading, GalleryPicker, SingleOptionDropdown, OptionsDropdown, VueTagsInput },
    props:{    
        baseSpecie:
        {
            type: Object,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            attemptedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            specie: new Specie( {}, {}, {}, {}, [], [] ),
            locationsOptions:[
                {label: this.$t("northwestWest"), key: "NorthwestWest"}, 
                {label: this.$t("mountainousNorthwest"), key: "MountainousNorthwest"}, 
                {label: this.$t("ultraBasicNortheast"), key: "UltraBasicNortheast"},
                {label: this.$t("northeastLeone"), key: "NortheastLeone"},
                {label: this.$t("hotEarth"), key: "HotEarth"},
                {label: this.$t("coldEarth"), key: "ColdEarth"},
                {label: this.$t("northCenter"), key: "NorthCenter"},
                {label: this.$t("limestoneMidwest"), key: "LimestoneMidwest"},
                {label: this.$t("sandyMidwest"), key: "SandyMidwest"},
                {label: this.$t("midwestOlisiponense"), key: "MidwestOlisiponense"},
                {label: this.$t("midwestCintrano"), key: "MidwestCintrano"},
                {label: this.$t("mountainousEastCentral"), key: "MountainousEastCentral"},
                {label: this.$t("centerEastOfCampina"), key: "CenterEastOfCampina"},
                {label: this.$t("southCentralMiocene"), key: "SouthCentralMiocene"},
                {label: this.$t("southCentralArrabidense"), key: "SouthCentralArrabidense"},
                {label: this.$t("midSouthPleistocene"), key: "MidSouthPleistocene"},
                {label: this.$t("northeastern"), key: "Northeastern"},
                {label: this.$t("southEast"), key: "SouthEast"},
                {label: this.$t("northSouthWest"), key: "NorthSouthWest"},
                {label: this.$t("southWest"), key: "SouthWest"},
                {label: this.$t("mountainousSouthwest"), key: "MountainousSouthwest"},
                {label: this.$t("algarveBaroque"), key: "AlgarveBaroque"},
                {label: this.$t("windward"), key: "Windward"},
                {label: this.$t("leeward"), key: "Leeward"},
                {label: this.$t("berlengas"), key: "Berlengas"},
            ],
            monthOptions:[
                {label: this.$t("january"), key: "1"}, 
                {label: this.$t("february"), key: "2"}, 
                {label: this.$t("march"), key: "3"},
                {label: this.$t("april"), key: "4"},
                {label: this.$t("may"), key: "5"},
                {label: this.$t("june"), key: "6"},
                {label: this.$t("july"), key: "7"},
                {label: this.$t("august"), key: "8"},
                {label: this.$t("september"), key: "9"},
                {label: this.$t("october"), key: "10"},
                {label: this.$t("november"), key: "11"},
                {label: this.$t("december"), key: "12"},
            ],
            commonName:"",
            habitat:"",
            synonym:"",
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
        }
    },
    mounted: function()
    {
        this.resetSpecie();
    },
    computed:
    {
        ...mapState('species', ['putSpecieOutput']),
        ...mapState('species', ['postSpecieOutput']),
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = this.alertOutput && Array.isArray(this.alertOutput) ? this.alertOutput : [];

            // Validate multi language fields
            for (const [key, value] of Object.entries(this.specie.physioGnomicTypes)) { if(!value) { result['PhysioGnomicTypes'] = this.$i18n.t("validateBothTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.specie.generalDistributions)) { if(!value) { result['GeneralDistributions'] = this.$i18n.t("validateBothTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.specie.habitats)) { if(!value || !value.length) { result['Habitats'] = this.$i18n.t("validateBothTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.specie.commonNames)) { if(!value || !value.length) { result['CommonNames'] = this.$i18n.t("validateBothTranslations"); break; }; }

            return result;
        },
        supportedLanguages: function()
        {
            return CONSTANTS.supportedLanguages
        }
    },
    methods:{
        genericValidator,
        errorValidator,
        resetSpecie(){
            if(!this.baseSpecie)
            {
                var physioGnomicTypes = {}; var generalDistributions = {}; var commonNames = {}; var habitats = {};
                CONSTANTS.supportedLanguages.forEach(language => { physioGnomicTypes[language.key] = ""; generalDistributions[language.key] = ""; commonNames[language.key] = []; habitats[language.key] = []; });
                this.specie = new Specie( physioGnomicTypes, generalDistributions, commonNames, habitats, [], []);
            }
            else
            {
                this.specie = deepClone(new Specie, this.baseSpecie);  
                
                var images = [];
                this.specie.images.forEach(function(image)
                {
                    images.push({url: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, image]), path: image});
                });
                this.specie.images = images;

                this.specie.floweringStartSeason = this.specie.floweringStartSeason.toString();
                this.specie.floweringEndSeason = this.specie.floweringEndSeason.toString();
            }
        },
        submitClicked(){
            this.attemptedSubmit = true;

            // Emit event
            if(this.specie.isValid())
            {
                this.submitting = true;
                this.$emit('submit-requested', this.specie);
            }
        },
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            router.push('/species/list');
        },
        onProcessTask: function(val)
        {
            if(val != null)
            {
                if(val)
                {
                    this.showConfirmationPopup = true;
                }

                this.submitting = false;
            }
        }
    },
    watch:
    {
        putSpecieOutput: function(val)
        {
            this.onProcessTask(val);
        },
        postSpecieOutput: function(val)
        {
            this.onProcessTask(val);
        },
        baseSpecie: function()
        {
            this.resetSpecie();
        },
        alertOutput: function()
        {
            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 
 
<style scoped>

@media only screen and (max-width: 767px) {
    .main-content {
        flex-direction: column;
    }
}
</style> 